<template>
    <v-container>
        <!-- Søknad oversikt -->

        <div class="body-2 grey lighten-2 d-flex" @click="showApplicationDetails = !showApplicationDetails" style="cursor: pointer;">
            <div>Søknadsdetaljene</div>
            <v-spacer></v-spacer>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="!showApplicationDetails" small>mdi-plus</v-icon>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="showApplicationDetails" small>mdi-minus</v-icon>
            </v-fade-transition>
        </div>
        <v-expand-transition :duration="1000">
            <v-simple-table v-if="showApplicationDetails" dense class="grey lighten-4">
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td style="width: 30%;">Registreringsdato</td>
                            <td>{{moment.unix(app.createdAt).format('YYYY-MM-DD')}}</td>
                        </tr>
                        <tr>
                            <td>Registrert av</td>
                            <td>{{`${app.createdBy.firstname} ${app.createdBy.lastname} - ${app.createdBy.email}`}}</td>
                        </tr>
                        <tr>
                            <td>Status</td>
                            <td>{{applicationStatusText(app.statuses[app.statuses.length -1])}}</td>
                        </tr>
                        <tr>
                            <td>Type utbetaling</td>
                            <td>{{app.advance? "forskuddsvis" : "etterskuddsvis"}}</td>
                        </tr>
                        <tr>
                            <td>Søknadsbeløp</td>
                            <td>{{app.foundationFunding}} av {{applicationBudget}}</td>
                        </tr>
                        <tr>
                            <td>Innvilget beløp</td>
                            <td>{{app.grant}}</td>
                        </tr>
                        <tr>
                            <td>Utbetalt beløp</td>
                            <td>{{paymentTotal}}</td>
                        </tr>
                        <tr>
                            <td>Kontonummer</td>
                            <td>{{app.account}}</td>
                        </tr>
                        <tr>
                            <td>Formål</td>
                            <td>{{purposes.map(p => p.name).join(", ")}}</td>
                        </tr>
                        <tr>
                            <td>Formålsområdet</td>
                            <td>{{area? area.name: undefined}}</td>
                        </tr>
                        <tr>
                            <td>Aldersgruppe</td>
                            <td>{{ageGroup? ageGroup.name: undefined}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-expand-transition>

        <div class="my-3"></div>

        <div class="body-2 grey lighten-2 d-flex" @click="showApplicationDescription = !showApplicationDescription" style="cursor: pointer;">
            <div>Beskrivelse</div>
            <v-spacer></v-spacer>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="!showApplicationDescription" small>mdi-plus</v-icon>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="showApplicationDescription" small>mdi-minus</v-icon>
            </v-fade-transition>
        </div>
        <v-expand-transition :duration="1000">
            <v-simple-table v-if="showApplicationDescription" dense class="grey lighten-4">
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td style="width: 30%;">Beskrivelse</td>
                            <td>{{app.description}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-expand-transition>

        <div class="my-3"></div>

        <div class="body-2 grey lighten-2 d-flex" @click="showApplicationBudget = !showApplicationBudget" style="cursor: pointer;">
            <div>Kostnadsbudsjett</div>
            <v-spacer></v-spacer>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="!showApplicationBudget" small>mdi-plus</v-icon>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="showApplicationBudget" small>mdi-minus</v-icon>
            </v-fade-transition>
        </div>
        <v-expand-transition :duration="1000">
            <v-simple-table v-if="showApplicationBudget" dense class="grey lighten-4">
                <template v-slot:default>
                    <tbody>
                        <div class="overline">innkjøpte varer</div>
                        <tr v-for="procurement in procurementsByCost" :key="procurement.id">
                            <td style="width: 30%;">{{procurement.description}}</td>
                            <td>{{procurement.cost}}</td>
                        </tr>
                        <tr>
                            <td style="width: 30%;" class="bottomborderless">SUM</td>
                            <td class="sum">{{procurementTotalByCost}}</td>
                        </tr>

                        <div class="overline mt-3">Egeninnsats</div>
                        <tr v-for="procurement in procurementsByHour" :key="procurement.id">
                            <td style="width: 30%;">{{procurement.description}}</td>
                            <td>{{procurement.hours * app.hourlyRate}}</td>
                        </tr>
                        <tr>
                            <td style="width: 30%;" class="bottomborderless">SUM</td>
                            <td class="sum">{{procurementTotalByHour}}</td>
                        </tr>
                        <tr>
                            <td style="width: 30%;">TOTALSUM</td>
                            <td class="totalsum">{{procurementTotalByCost + procurementTotalByHour}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-expand-transition>

        <div class="my-3"></div>

        <div class="body-2 grey lighten-2 d-flex" @click="showApplicationFinancing = !showApplicationFinancing" style="cursor: pointer;">
            <div>Finansiering</div>
            <v-spacer></v-spacer>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="!showApplicationFinancing" small>mdi-plus</v-icon>
            </v-fade-transition>
            <v-fade-transition hide-on-leave>
                <v-icon v-if="showApplicationFinancing" small>mdi-minus</v-icon>
            </v-fade-transition>
        </div>
        <v-expand-transition :duration="1000">
            <v-simple-table v-if="showApplicationFinancing" dense class="grey lighten-4">
                <template v-slot:default>
                    <tbody>
                        <tr>
                            <td style="width: 30%;">Totalfinansiering</td>
                            <td>{{app.totalFunding === 1 || app.totalFunding === true ? "Ja" : "Nei"}}</td>
                        </tr>
                        <tr>
                            <td>Egenandel</td>
                            <td>{{app.ownFunding}}</td>
                        </tr>
                        <tr>
                            <td>Stiftelsen</td>
                            <td>{{app.foundationFunding}}</td>
                        </tr>
                        <tr>
                            <td class="bottomborderless">SUM</td>
                            <td class="sum">{{app.ownFunding + app.foundationFunding}}</td>
                        </tr>

                        <div class="overline mt-3">Andre</div>
                        <tr v-for="funding in app.fundings" :key="funding.id">
                            <td style="width: 30%;">{{funding.description}}</td>
                            <td>{{funding.amount}}</td>
                        </tr>
                        <tr>
                            <td class="bottomborderless">SUM</td>
                            <td class="sum">{{fundingsTotalOther}}</td>
                        </tr>
                        <tr>
                            <td>TOTALSUM</td>
                            <td class="totalsum">{{app.ownFunding + app.foundationFunding + fundingsTotalOther}}</td>
                        </tr>
                    </tbody>
                </template>
            </v-simple-table>
        </v-expand-transition>

    </v-container>
</template>

<script>
import * as axios from "axios";
import * as moment from "moment";
import { ApplicationChoiceType, ProcurementType } from "../utilities/enums";
export default {
    props: {
        id: { default: undefined },
        expanded: { default: true }
    },
    data() {
        return {
            app: {
                name: undefined,
                createdAt: 0,
                createdBy: {},
                statuses: [],
                payments: [],
                fundings: [],
                procurements: []
            },
            showApplicationDetails: false,
            showApplicationDescription: false,
            showApplicationBudget: false,
            showApplicationFinancing: false,
            moment: moment
        };
    },
    computed: {
        applicationBudget() {
            return this.procurementTotalByCost + this.procurementTotalByHour;
        },
        purposes() {
            if (!this.app.applicationChoices) return [];

            return this.app.applicationChoices.filter(a => a.type === ApplicationChoiceType.PURPOSE && a.selected);
        },
        area() {
            if (!this.app.applicationChoices) return { name: "-" };
            let areas = this.app.applicationChoices.filter(a => a.type === ApplicationChoiceType.AREA);
            let selectedArea = areas.find(a => a.selected);
            return selectedArea;
        },
        ageGroup() {
            if (!this.app.applicationChoices) return { name: "-" };
            let ageGroup = this.app.applicationChoices.find(a => a.type === ApplicationChoiceType.AGEGROUP && a.selected);
            return ageGroup;
        },
        procurementsByCost() {
            if (!this.app.procurements) return [];

            return this.app.procurements.filter(p => p.type == ProcurementType.COST);
        },
        procurementsByHour() {
            if (!this.app.procurements) return [];

            return this.app.procurements.filter(p => p.type == ProcurementType.HOUR);
        },
        procurementTotalByCost() {
            if (!this.procurementsByCost) return 0;

            return this.procurementsByCost.reduce((acc, cur) => {
                return acc + cur.cost;
            }, 0);
        },
        procurementTotalByHour() {
            if (!this.procurementsByHour) return 0;

            return this.procurementsByHour.reduce((acc, cur) => {
                return acc + cur.hours * this.app.hourlyRate;
            }, 0);
        },
        paymentTotal() {
            if (!this.app.payments) return 0;

            return this.app.payments.reduce((acc, cur) => {
                return acc + cur.amount;
            }, 0);
        },
        fundingsTotalOther() {
            if (!this.app.fundings) return 0;

            return this.app.fundings.reduce((acc, currentFundingOther) => {
                return acc + currentFundingOther.amount;
            }, 0);
        }
    },
    beforeMount() {
        this.showApplicationDetails = this.expanded;
        this.showApplicationDescription = this.expanded;
        this.showApplicationBudget = this.expanded;
        this.showApplicationFinancing = this.expanded;

        
    },
    async mounted() {
        let response = await axios.get(`/application/${this.$props.id}`, {
            params: {
                include: "[createdBy,ownedBy,statuses,payments,fundings,procurements,applicationChoices]"
            }
        });
        let application = response.data;
        // this.$set(this, "app", application);
        this.app = application;
    }
};
</script>

<style lang="scss">
</style>